import { useRef, useState } from "react";
import { UploadCloud, Loader2, X, FileText } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export default function PdfUpload({ value, onChange, label = "PDF" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url);
      toast.success("PDF hochgeladen.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div>
      <label className="block text-xs font-semibold uppercase tracking-wider text-[var(--mf-grey)] mb-1.5">{label}</label>
      <div className="flex items-center gap-3">
        {value ? (
          <a href={value} target="_blank" rel="noopener noreferrer" data-testid="pdf-upload-preview"
            className="flex items-center gap-2 text-sm text-[var(--mf-ink)] underline decoration-[var(--mf-line)] hover:decoration-[var(--mf-red)]">
            <FileText size={16} className="text-[var(--mf-red)]" /> PDF ansehen
          </a>
        ) : (
          <span className="text-xs text-[var(--mf-grey)]">kein PDF hochgeladen</span>
        )}
        <div className="flex items-center gap-2">
          <input ref={ref} type="file" accept="application/pdf" onChange={upload} className="hidden" data-testid="pdf-upload-input" />
          <button type="button" onClick={() => ref.current?.click()} disabled={busy}
            className="text-xs inline-flex items-center gap-1.5 border border-[var(--mf-line)] px-3 py-2 hover:bg-[var(--mf-mist)] disabled:opacity-60" data-testid="pdf-upload-btn">
            {busy ? <Loader2 size={13} className="animate-spin" /> : <UploadCloud size={13} />} PDF hochladen
          </button>
          {value && (
            <button type="button" onClick={() => onChange("")} className="text-xs text-[var(--mf-red)] inline-flex items-center gap-1" data-testid="pdf-upload-remove"><X size={12} /> Entfernen</button>
          )}
        </div>
      </div>
      <input className="w-full mt-2 bg-white border border-[var(--mf-line)] px-3 py-2 text-sm focus:border-[var(--mf-red)]"
        placeholder="oder PDF-URL / Pfad" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid="pdf-upload-url" />
    </div>
  );
}
